import Button from "@mui/material/Button";
import { Plus } from "@/assets/svgs/Plus";

export default function EntityCreateButton(props) {
    const { setPopupOpen } = props;
    const handleEntityCreateButton = () => {
        setPopupOpen(true);
    };
    return (
        <Button
            data-testid={props.datatestid}
            endIcon={<Plus />}
            onClick={handleEntityCreateButton}
            color="primary"
        >
            Add
        </Button>
    );
}
